import { render, staticRenderFns } from "./msg.vue?vue&type=template&id=4610734c&scoped=true&lang=html&"
import script from "./msg.vue?vue&type=script&lang=js&"
export * from "./msg.vue?vue&type=script&lang=js&"
import style0 from "./msg.vue?vue&type=style&index=0&id=4610734c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4610734c",
  null
  
)

component.options.__file = "msg.vue"
export default component.exports